module.exports = __webpack_public_path__ + "media/images/new_landing/about/story-4-df589668fb00012c71cc3b65e698d5e4.jpg";